const defaultTitle = 'Angeplus';

export const PAGE_TITLE = {
  defaultTitle,
  privacyPolicy: defaultTitle.concat(' | Políticas de privacidade'),
  termsOfUse: defaultTitle.concat(' | Termos e condição de uso'),
};
